const tool = {}

tool.dateFormat = function (date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
        }
    }
    return fmt;
}


tool.padLeftZero = function (str) {
    return ('00' + str).substr(str.length);
}



tool.timestampFormat  = function(str){  
    var oDate = new Date(str),  
    oYear = oDate.getFullYear(),  
    oMonth = oDate.getMonth()+1,  
    oDay = oDate.getDate(),  
    oHour = oDate.getHours(),  
    oMin = oDate.getMinutes(),  
    oSen = oDate.getSeconds(),  
    oTime = oYear +'-'+ getzf(oMonth) +'-'+ getzf(oDay) +' '+ getzf(oHour) +':'+ getzf(oMin) +':'+getzf(oSen);//最后拼接时间  
    return oTime;  
} 
//补0操作  
tool.getzf = function (num){
    if(parseInt(num) < 10){  
        num = '0'+num;  
    }  
    return num;  
}  


tool.ChatMsg = function(action , sender, roomId, msg, terminal, senderHeader){
	this.action = action;
	this.sender = sender;
	this.roomId = roomId;
	this.msg = msg;              //消息
	this.terminal = terminal;    //终端
	this.senderHeader= senderHeader; //头像
}


tool.strlen = function (str){
    var len = 0;
    for (var i=0; i<str.length; i++) { 
     var c = str.charCodeAt(i); 
    //单字节加1 
     if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) { 
       len++; 
     } 
     else { 
      len+=2; 
     } 
    } 
    return len;
}


tool.mobileStr = function (mobile){
	if(mobile && mobile.length == 11){
		// let mobile_start = mobile.substring(0,4);
		// let mobile_end = mobile.substring(8,12);
		// return mobile_start+ "****" + mobile_end;
        return mobile.substr(0,3) + "****" + mobile.substr(7)
	}else{
		return "****"
	}
}

/**
 * 手机号正则校验
 */
tool.checkPhoneNumber = function(phoneNumber){
    var regexp = /^[1]([3-9])[0-9]{9}$/
    return regexp.test(phoneNumber)
}

/**
 * 判断是否微信打开
 */
tool.isWxEnv = function(){
    var broser = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配broser 中是否含有MicroMessenger字符串
    // 如果是微信浏览器内，则调用微信内支付
    if (broser.match(/MicroMessenger/i) == "micromessenger") {
        return true
    } else {
        /**H5微信外支付  暂时不做*/
        //this.$toast("请使用微信浏览器打开页面，否则不能支付");
        return false
    }
}

/**
 * 以snsapi_base为scope发起的网页授权,获取code
 */
tool.getCOdeBySnsapiBase = function(url){
    let wxappid = "wxc73393bede2ae78a"; // 微信公众号appid
    let str =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        wxappid +
        "&redirect_uri=" +
        url +
        "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
        return str
}


/**
 * 时间截取,年月日
 */
 tool.cutTimeYmd = function(date){
    if (date != undefined) {
        var result = date.substring(0, 10);
        return result
    }
}


/**
 * 判断用户终端类型
 */
tool.isIOS = function(){
    if (/(iPhone|iPad|iPod|iOS|Mac)/i.test(navigator.userAgent)) {
        //判断是ios用户的时候执行某种操作
        return true;
    } else if (/(Android)/i.test(navigator.userAgent)) {
        //判断是安卓用户的时候执行某种操作
        return false;
    } else {
        //其他类型的时候执行某种操作
        return false;
    };    
}

/**手机号码验证 */
tool.mobileValidator = function(val){
    let patt = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if (patt.test(val)) {
        return true;
    } else {
        return false;
    }
}


export default tool;

// export {
//     dateFormat ,
//     timestampFormat,
//     ChatMsg,
//     strlen,
//     mobileStr,
//     checkPhoneNumber
// }